import React from "react";

import "./ProgressBarMobile.css";

import { Heading } from "./../../../../StyledComponents";

export default (props) => {
  if (props.progresBarData.length === 0) {
    return null;
  }

  const currentProgress = props.progresBarData.find(
    (e) => e.status === "IN_PROGRESS"
  );

  if (!currentProgress) return null;

  const nextStep = props.progresBarData.find(
    (e) => e.value === +currentProgress.value + 1
  );

  const progress = (currentProgress.value / props.progresBarData.length) * 100;

  return (
    <div
      className="progress-bar-mobile__container"
      automationid="SalesLeads_Div_ProgressMobile-1"
    >
      <div
        className="progress-bar-mobile__main"
        automationid="SalesLeads_Div_ProgressMobile-2"
        style={
          currentProgress.value === props.progresBarData.length
            ? { display: "none" }
            : null
        }
      >
        <div
          className="progress-bar-mobile__step-title"
          automationid="SalesLeads_Div_ProgressMobile-3"
        >
          Step {currentProgress.value} of {props.progresBarData.length}
        </div>
        <Heading
          style={{ padding: 0 }}
          automationid="SalesLeads_H1_ProgressMobile-21"
        >
          {currentProgress.title}
        </Heading>
        <div
          className="progress-bar-mobile__step-subtitle"
          automationid="SalesLeads_Div_ProgressMobile-32"
        >
          Next: {nextStep && nextStep.title}
        </div>
      </div>
      <div
        style={{ width: `${progress}%` }}
        automationid="SalesLeads_Div_ProgressMobile-41"
        className="progress-bar-mobile__progress-bar"
      ></div>
    </div>
  );
};
